import { render, staticRenderFns } from "./CommandeByAffaire.vue?vue&type=template&id=70a1b404&"
import script from "./CommandeByAffaire.vue?vue&type=script&lang=js&"
export * from "./CommandeByAffaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a1b404')) {
      api.createRecord('70a1b404', component.options)
    } else {
      api.reload('70a1b404', component.options)
    }
    module.hot.accept("./CommandeByAffaire.vue?vue&type=template&id=70a1b404&", function () {
      api.rerender('70a1b404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vente-creance/commandes/CommandeByAffaire.vue"
export default component.exports